export default {
    "178ba26728": "Learn about our products",
    "43bd0cb57c": "Advantages and services",
    "015d1bcd47": "Industry Solutions",
    "d00426bc48": "Cooperating organisations",
    "9ff28b81c4": "Privacy Policy | Terms of Use | Laws and Regulations",
    "09135b4480": "Hangzhou RoyalFlush Data Development Co., Ltd. All rights reserved",
    "603f4f1f4b": "Zhejiang ICP No. 15046002 Zhejin Xinbei (2021) No. 1",
    "4a7ee8f5ee": "Download APP",
    "601efab6ed": "Apply for a trial",
    "e4cc999756": "Financial data terminal", 
    "49c8953b28": "The most comprehensive and latest Chinese financial market quotation, news and basic information. Including Chinese stocks, bonds , funds, futures, indexes, foreign exchanges, etc.",
    "68051bf4aa": "Database", 
    "e5febe530a": "The standard database interface provides users with strongly internal structured, highly independent, clearly corresponding, safe and reliable, all-weather standard data and customized data.",
    "31f8a7a967": "Data interface",
    "8f4105595a": "The standard data interface provides quantitative investors with financial data and support users to acquire data, build quantification models and develop strategies.",
    "1c13a2694a": "Mobile APP",
    "aa9b49f713": "Market & financial information，intelligent investment & research tools，content production & distribution platform，all in one.",
    "74bb5fe5c1": "Intelligent search",
    "fb92103b7c": "Advanced machine learning technology. One click helps the user reach the required data and information.",
    "a56b94485d": "Unstructured database",
    "5c7fe7de83": "Our database provides unstructured financial data that financial research institutes need through intelligent algorithm technology.",
    "fae7335381": "Chat function intelligently answers financial questions,Talk to AI and get financial information.",
    "c1dbcf0924": "AI-Writing",
    "e4cdee6595": "Using big data and AI technology to intelligently generate research report content.",
    "a13f0cfec8": "Broker",
    "e31ff0f841": "Support research, trading, wealth management and other scenarios",
    "f14b4f28c4": "Bank",
    "fb771c3a67": "Support financial markets, public credit, retail and other fields",
    "bf8214c421": "Fund",
    "e0212b388a": "Support fund investment research, trading, wealth management and other businesses",
    "04c9e3ab21": "Cooperation",
    "21c42cd822": "Covering financing, industry analysis, and risk monitoring scenarios",
    "c7814cb2c3": "Future",
    "ece231a465": "Support domestic and international futures research , commodity arbitrage, etc. ",
    "0d98c74797": "Other",
    "ec0572e733": "Covering more areas such as insurance, asset management, futures, and more"
}